var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIconred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8959 1.92448C14.8644 1.17041 13.7074 0.627146 12.4572 0.309598C11.648 0.104292 10.8182 0 9.99093 0C7.47215 0 5.08522 0.973237 3.27746 2.6107C3.25049 2.62785 3.22383 2.6464 3.1992 2.66885C3.17099 2.69457 3.14652 2.72248 3.12485 2.75225C2.07355 3.74448 1.22977 4.96634 0.688074 6.35566C0.537179 6.74118 0.40935 7.14025 0.308339 7.54105C-1.04757 12.8839 2.19564 18.3342 7.53861 19.6902C8.34827 19.8956 9.17852 20 10.0063 20C14.5804 20 18.5614 16.8993 19.688 12.4598C20.698 8.48115 19.2094 4.34568 15.8961 1.92446L15.8959 1.92448ZM7.81319 18.6072C3.06791 17.4026 0.186656 12.562 1.39143 7.8153C1.48122 7.45909 1.59487 7.10505 1.72892 6.7624C2.15153 5.6785 2.78098 4.70962 3.56055 3.89262L15.5078 16.9685C13.9821 18.1765 12.0615 18.8827 10.0059 18.8827C9.27086 18.8825 8.53291 18.7901 7.81335 18.6072L7.81319 18.6072ZM18.6047 12.1848C18.2074 13.7506 17.4094 15.1277 16.3385 16.2203L4.38047 3.13329C5.93791 1.86262 7.91392 1.11714 9.99054 1.11714C10.7254 1.11714 11.4626 1.20974 12.182 1.39228C13.2931 1.67429 14.3204 2.1566 15.2362 2.82618C18.1793 4.97686 19.5014 8.65035 18.6046 12.1846L18.6047 12.1848Z",
    fill: "#FF7171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIconred);
export default __webpack_public_path__ + "static/media/blockIconred.b96ba68855ed51efb493d5a2213a2b25.svg";
export { ForwardRef as ReactComponent };